import React from 'react'
const Error404 = () => {
  return (
            <>
                  <div className='error card_box'>
                      <h1>404</h1>
                      <p>Page Not Found</p>
                  </div>
            </>
  )
}

export default Error404